import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";

const BackToOrderListButton = () => {
  const navigate = useNavigate();
  const navigateToOrderList = () => navigate("/orders");
  return (
    <IconButton onClick={navigateToOrderList} color="primary" sx={{ bgcolor: "rgba(13, 110, 253, 0.08)" }}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default BackToOrderListButton;
